const spelledNumbers: Record<string, string> = {
  jeden: "1",
  jedna: "1",
  jedno: "1",
  dwa: "2",
  dwie: "2",
  trzy: "3",
  cztery: "4",
  pięć: "5",
  sześć: "6",
  siedem: "7",
  osiem: "8",
  dziewięć: "9",
  dziesięć: "10",
  numer: "",
  numerze: "",
  numeru: "",
  numerem: ""
};

const punctuationRegex = /[.,;:!?()\[\]{}"'\-–—/\\]/g;

export function toAscii(input: string): string {
  return input
    .toLowerCase()
    .replace(/[ą]/g, "a")
    .replace(/[ć]/g, "c")
    .replace(/[ę]/g, "e")
    .replace(/[ł]/g, "l")
    .replace(/[ń]/g, "n")
    .replace(/[ó]/g, "o")
    .replace(/[ś]/g, "s")
    .replace(/[ź]/g, "z")
    .replace(/[ż]/g, "z")
    .replace(/[Ą]/g, "A")
    .replace(/[Ć]/g, "C")
    .replace(/[Ę]/g, "E")
    .replace(/[Ł]/g, "L")
    .replace(/[Ń]/g, "N")
    .replace(/[Ó]/g, "O")
    .replace(/[Ś]/g, "S")
    .replace(/[Ź]/g, "Z")
    .replace(/[Ż]/g, "Z");
}

export function normalize(input: string): string {
  let text = input.toLowerCase();
  for (const [word, digit] of Object.entries(spelledNumbers)) {
    const re = new RegExp(`\\b${word}\\b`, "g");
    text = text.replace(re, digit);
  }
  return text.replace(punctuationRegex, " ").replace(/\s+/g, " ").trim();
}

export function tokenize(input: string): string[] {
  const base = normalize(input);
  return base.split(/\s+/).filter(Boolean);
}

export function ngrams(tokens: string[], maxN: number = 4): string[] {
  const out: string[] = [];
  for (let i = 0; i < tokens.length; i++) {
    for (let n = 1; n <= maxN && i + n <= tokens.length; n++) {
      out.push(tokens.slice(i, i + n).join(" "));
    }
  }
  return out;
}
